import React from "react";
import styles from "./About.module.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Steps from "../Components/Steps";
import androidEconometra from "../Assets/Images/androidEconometra.jpeg";
import iosEconometra from '../Assets/Images/econometra_ios.png';
import laptop from "../Assets/Images/laptop-1920.jpg";
import bonferWeb from "../Assets/Images/web_Bonfer.png";
import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";

const About = () => {
  const listSteps = [
    { id: 1, text: "Explícanos tu idea" },
    { id: 2, text: "Crearemos un prototipo del proyecto" },
    { id: 3, text: "Elaboraremos el presupuesto" },
    { id: 4, text: "Desarrollaremos el proyecto" },
    { id: 5, text: "Publicaremos o te lo entregaremos" },
    { id: 6, text: "¡A disfrutar de tu idea hecha realidad!" },
  ];

  return (
    <div className={styles.combined}>
      <p className={styles.title}>
          Sumergir tu negocio en la era digital nunca fue <b>tan fácil.</b>
        </p>
      {/* Content Section */}
      <div className={styles.contentSection}>
        
        {/* Left Column */}
        <div className={styles.rightColumn}>
         
          {listSteps.map((step) => (
            <Steps key={step.id} text={step.text} step={step.id} />
          ))}
        </div>
        {/* Right Column */}
        <div className={styles.leftColumn}>
          <div className={styles.leftSection}>
            <img
              className={styles.tecnoImage}
              src={laptop}
              alt="imagen tecnologías"
            />
          </div>
          <div className={styles.rightSection}>
            <ul>
              <li>Páginas web</li>
              <li>Aplicaciones móviles</li>
              <li>Asesoría digital</li>
              <li>Servicios de consultoría</li>
              <li>Soporte y Mantenimiento</li>
              <li>Ecommerce</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Carousel Section */}
      <hr></hr>
      <div className={styles.carouselContainer}>
         <h2 className={styles.subtitle}>
            Algunos de nuestros proyectos
          </h2>
        <Carousel
          className={styles.carousel}
          infiniteLoop
          transitionTime={900}
          showThumbs={false}
          stopOnHover={false}
          showIndicators={false}
          showStatus={false}
          renderArrowPrev={(clickHandler, hasPrev) => (
            <button
              className={`${styles.customPrevArrow} ${
                hasPrev ? "" : styles.hidden
              }`}
              onClick={clickHandler}
            >
              <FaArrowCircleLeft />
            </button>
          )}
          renderArrowNext={(clickHandler, hasNext) => (
            <button
              className={`${styles.customNextArrow} ${
                hasNext ? "" : styles.hidden
              }`}
              onClick={clickHandler}
            >
              <FaArrowCircleRight />
            </button>
          )}
        >
          <div className={styles.slideHolder}>
            <img src={androidEconometra} alt="Imagen de la App Econometra en Android" />
            <div className={styles.textContainer}>
              <h2>App Android Econometra</h2>
              <p>Desarrollo para Android en React Native</p>
              <a
                href="https://play.google.com/store/apps/details?id=com.econometraapp"
                target="_blank"
                rel="noopener noreferrer"
                alt="botón Ver"
              >
                Ver
              </a>
            </div>
          </div>
          <div className={styles.slideHolder}>
            <img src={iosEconometra} alt="Imagen de la App Econometra en iOS" />
            <div className={styles.textContainer}>
              <h2>App iOS Econometra</h2>
              <p>Desarrollo para iOS en React Native</p>
              <a
                href="https://apps.apple.com/es/app/econometra/id6670447550"
                target="_blank"
                rel="noopener noreferrer"
                alt="botón Ver"
              >
                Ver
              </a>
            </div>
          </div>
          <div className={styles.slideHolder}>
            <img
              src={bonferWeb}
              alt="Imagen de la web corporativa Bonfer Tech"
            />
            <div className={styles.textContainer}>
              <h2>Web BonFer Tech</h2>
              <p>Desarrollo en React Js</p>
              <a
                href="https://bonfertech.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver
              </a>
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  );
};

export default About;
